import { Toast } from "radix-ui";
import RemoveIcon from "../../atoms/images/RemoveIcon";

const ToastCloseButton = () => {
  return (
    <Toast.Close className="absolute top-4 right-4 md:top-6 md:right-6">
      <RemoveIcon />
    </Toast.Close>
  );
};

export default ToastCloseButton;
